
<template>
	<v-dialog
			content-class="wrapperDialogDuties"
			:value="true"
			width="1200"
			transition="dialog-bottom-transition"
	>
		<v-card>
			<div class="dialogHead">
				<span class="customersHead-title">Generate invoice</span>

				<button type="button" @click="closeDialog">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>

			<div class="dialogMain">
				<div class="left">
					<field
							margin="0"
							label="Service"
							placeholder="Select service"
							@updateAutocomplete="onAutocomplete($event, 'service_id')"
							:autocompleteValue="service_def"
							item-text="name"
							:items="serviceList"
							:isClearable="false"
							is-autocomplete
							is-readonly
							is-disabled
					></field>
					<div class="dateWrap">
						<field
								margin="0"
								type="text"
								label="Date from"
								placeholder="Enter date"
								:dateValue="from"
								@updateDate="onDate($event, 'from')"
								is-date
								is-no-title
						></field>
						<field
								margin="0"
								type="text"
								label="Date to"
								placeholder="Enter date"
								:dateValue="to"
								@updateDate="onDate($event, 'to')"
								is-date
								is-no-title
						></field>
					</div>
					<div class="controls">
						<custom-btn
								is-all-elements
								text="Additional Payment"
								custom-class="apply extended"
								margin="0"
								@updateEvent="onAddItem"
								:icon-attrs="{ iconId: 'plus', width: 20, height: 20 }"
						></custom-btn>
					</div>
					<div class="controls">
						<custom-btn
								is-all-elements
								text="Generate"
								custom-class="apply extended"
								margin="0"
								@updateEvent="onSave"
								:icon-attrs="{ iconId: 'icon-magic', width: 20, height: 20 }"
						></custom-btn>
					</div>
				</div>
				<div class="right">
					<no-info
							v-if="payments && payments.length <= 0"
							text="📄 No additional payments."
							padding="0"
					/>
					<div v-else class="generateInvoiceWrap" >
						<generate-invoice-item
								v-for="(item, index) in payments"
								:item="item"
								:index="index"
								:key="getUniqKey(index)"
								:customers="customersList"
								:isInvalid="invalidIndexes.includes(index)"
								@updateData="onData"
								@updateDeleteItem="onDeleteItem"
						/>
					</div>

				</div>
			</div>
		</v-card>

		<dialog-remove
				v-if="isDialogRemove"
				:titleRemove="titleRemove"
				:textRemove="textRemove"
				@updateRemove="onRemove"
				@updateCloseRemove="onCloseRemove"
		></dialog-remove>
	</v-dialog>
</template>

<script>
import getDefaultDate from "@/helper/getDefaultDate";
import GenerateInvoiceItem
from "@/pages/Accounting/CustomerInvoices/GenerateInvoice/GenerateInvoiceItem/GenerateInvoiceItem.vue";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TITLE } from "@/components/Maintenance/EmployeesForm/constants";
import getUniqId from "@/helper/getUniqId";
import { mapActions } from "vuex";

export default {
	name: "GenerateInvoice",
	components: { DialogRemove, NoInfo, GenerateInvoiceItem },
	props: {
		customersList: Array,
		serviceList: Array
	},
	data: () => ({
		invalidIndexes: [],
		from: getDefaultDate(),
		to: getDefaultDate(),
		service_def: { id: 3, name: "Safety" },
		service_id: 3,
		payments: [],

		isDialogRemove: false,
		activeItem: null,
		activeItemIndex: null,
		titleRemove: null,
		textRemove: null,
	}),
	methods: {
		...mapActions([
			'setAlert',
		]),
		getUniqKey(id) {
			return id + getUniqId();
		},
		async onRemoveItem() {
			await this.onRemoveSafetyStatements(this.removeId);
			this.isRemove = false;
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},
		onRemove() {
			console.log('Удаляем по индексу:', this.activeItemIndex);
			this.payments.splice(this.activeItemIndex, 1);
			this.onCloseRemove();
		},

		async onDate(date, key) {
			this[key] = date;
		},
		closeDialog() {
			this.$emit('updateClosePopup');
		},
		onData(args) {
			const { index, key, value } = args;
			const idx = Number(index);

			if (this.payments[idx]) {
				this.$set(this.payments[idx], key, value);
			} else {
				// создаём новый пустой объект и добавляем только одно нужное поле
				const newItem = {};
				this.$set(newItem, key, value);
				this.$set(this.payments, idx, newItem);
			}
		},
		onAddItem() {
			const defItem = {
				"customer_id": null,
				"amount": null,
				"description": null
			};
			this.payments.push(defItem);
		},
		onDeleteItem({ index, item, customer, amount }) {
			this.activeItem = item;
			this.activeItemIndex = index;
			const text0 = `❓ Do you really want to delete the invoice from the invoice generation queue?`;
			const text1 = `❓ Do you really want to delete the invoice assigned to 🧾 <b>${ customer }</b> (total: 💰 <b>${ amount }</b>) from the invoice generation queue?`;

			const title = TITLE.REMOVE_DOCUMENT;
			const text = (!customer || !amount) ? text0 : text1;
			this.onRemoveDialog({ title, text });
		},
		async onSave() {
			this.invalidIndexes = [];

			this.payments.forEach((payment, index) => {
				const isInvalid =
						!payment.customer_id ||
						!payment.amount?.toString().trim() ||
						!payment.description?.toString().trim();

				if (isInvalid) {
					this.invalidIndexes.push(index);
				}
			});

			if (this.invalidIndexes.length > 0) {
				await this.setAlert({ type: "info", message: "❌ Please fill in all fields in each invoice item before saving." });
				return;
			}
			// if (this.payments.length === 0) {
			// 	await this.setAlert({ type: "info", message: "🧾 To generate invoices, please add and complete at least one invoice." });
			// 	return;
			// }

			const { from, to, service_id, payments } = this.$data;

			// Все валидно — отправляем
			this.$emit('updateGenerate', { from, to, service_id, payments });

		}

	},
};
</script>

<style lang="scss">
@import "GenerateInvoice";
</style>
